const GmailAddOnLogin = () => {
    
    return(
            <iframe title="gmail addon eprocessify" src="https://script.google.com/macros/s/AKfycbzTY6PjlZKxg9QPL60gUvZLGnciIR2Gw5SSe7ncIOu2YULZxU2Ns5ypbSGhzmd56vwT/exec" frameborder="0" target="_parent"  width="100%" height="500px"></iframe>
                        
    )
}

export default GmailAddOnLogin;